export enum FILE_SPARE_PART_REQUEST_LINES_DOMAIN {
  LIST = 'list',
  BY_FILE_ID = 'byFileId',
}

export const FILE_SPARE_PART_REQUEST_LINES_DOMAIN_KEY = 'fileRequestLines';
